import { DynamicAlignmentMapStore } from './DynamicAlignmentMapStore';
import { DynamicAlignmentProfileStore } from './DynamicAlignmentProfileStore';
import { DynamicAlignmentTableStore } from './DynamicAlignmentTableStore';
import { ProfileStoreType } from '../DynamicProfileEnums';
import { DynamicProfileHubBase } from '../DynamicProfileHubBase';

class DynamicAlignmentHub extends DynamicProfileHubBase {
  /** override fields */
  protected _profileStore: DynamicAlignmentProfileStore | undefined;
  protected _mapStore: DynamicAlignmentMapStore | undefined;
  protected _tableStore: DynamicAlignmentTableStore | undefined;

  /** Use a factory method pattern: create an actor only when it's needed; make it possible to
   *  expand with complexity through inheritance hierarchy of stores if needed */
  public createStore(storeType: ProfileStoreType, option: any = void 0) {
    switch (storeType) {
      case ProfileStoreType.MAP:
        this._mapStore = new DynamicAlignmentMapStore(this);
        this.MapStore!.MapView = option?.mapView;
        this.disposer.Track(this._mapStore);
        break;

      case ProfileStoreType.PROFILE:
        this._profileStore = new DynamicAlignmentProfileStore(this);
        this.disposer.Track(this._profileStore);
        break;

      case ProfileStoreType.TABLE:
        this._tableStore = new DynamicAlignmentTableStore(this);
        this.disposer.Track(this._tableStore);
        break;

      default:
        // console.log(ProfileStoreType[storeType] + ' store type is not supported yet.');
        break;
    }
  }
  /** for compatibility to existing code */
  private _setStore;
  set setStore(setStore) {
    this._setStore = setStore;
  }

  get setStore() {
    return this._setStore;
  }

  private _alignmentStore;
  public get alignmentStore() {
    return this._alignmentStore;
  }
  public set alignmentStore(value) {
    this._alignmentStore = value;
  }

  public get isAlignmentValid(): boolean {
    let result = true;
    if (this._mapStore) result = this._mapStore.isAlignmentValid;

    return result;
  }

  public deleteStationFromMapClick(deleteFunction) {
    this._mapStore?.deleteStationFromMapClick(deleteFunction);
  }

  public clearDeleteStation() {
    this._mapStore?.clearDeleteStation();
  }
}

export { DynamicAlignmentHub };
